import { Welcomepage } from '../containers';

const Welcome = () => {
  return (
    <div>
        <div className="Welcome">
          <Welcomepage />
        </div>
    </div>
  )
}

export default Welcome